import Vue from 'vue';
import Vuex from 'vuex';

/* Import module */
import auth from './modules/auth.module';
import navigation from './modules/navigation.module';
import pagination from './modules/pagination.module';
import snackbar from './modules/snackbar.module';
import loading from './modules/loading.module';
import confirm from './modules/confirm.module';
import search from './modules/search.module';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    publicPath: process.env.BASE_URL,
    baseAssetUrl: process.env.VUE_APP_BASE_ASSET_URL,
    counter: 1
  },
  modules: {
    auth,
    navigation,
    pagination,
    snackbar,
    loading,
    confirm,
    search
  },
});
